/**
 * Project story drawer — Alpine wrapper for a left-slide overlay used on
 * tablet breakpoints (md → lg-1) to host the project's body copy. Desktop
 * renders prose inline; mobile stacks it. CSP-safe: method refs only.
 */
export default function projectStoryDrawer() {
    return {
        open: false,

        show() {
            this.open = true;
            document.body.classList.add('overflow-hidden');
        },

        close() {
            this.open = false;
            document.body.classList.remove('overflow-hidden');
        },

        toggle() {
            if (this.open) {
                this.close();
            } else {
                this.show();
            }
        },
    };
}
